import { Injectable } from '@angular/core';

const TOKEN_KEY = 'menuvia_admin_token';
const ADMIN_KEY = 'menuvia_admin_profile';

@Injectable({ providedIn: 'root' })
export class TokenStorage {
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  }

  clearToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  }

  getAdminProfile<T>(): T | null {
    const raw = localStorage.getItem(ADMIN_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  }

  setAdminProfile<T>(profile: T): void {
    localStorage.setItem(ADMIN_KEY, JSON.stringify(profile));
  }

  clearAdminProfile(): void {
    localStorage.removeItem(ADMIN_KEY);
  }

  clearAll(): void {
    this.clearToken();
    this.clearAdminProfile();
  }
}
